// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import axios from "axios";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import "./MemberAccess.css";

// const MemberAccess = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const searchParams = new URLSearchParams(location.search);
//   const redirectPath = searchParams.get("redirect") || "/abstract-submission";

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [rememberMe, setRememberMe] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");

//   useEffect(() => {
//     const rememberedEmail = localStorage.getItem("rememberedEmail");
//     const rememberedPassword = localStorage.getItem("rememberedPassword");
//     if (rememberedEmail && rememberedPassword) {
//       setEmail(rememberedEmail);
//       setPassword(rememberedPassword);
//       setRememberMe(true);
//     }
//   }, []);

//   const handleLogin = async () => {
//     setLoading(true);
//     setMessage("");

//     if (rememberMe) {
//       localStorage.setItem("rememberedEmail", email);
//       localStorage.setItem("rememberedPassword", password);
//     } else {
//       localStorage.removeItem("rememberedEmail");
//       localStorage.removeItem("rememberedPassword");
//     }

//     try {
//       const response = await axios.post("https://api.rescons.in/login", {
//         email,
//         password,
//       });

//       if (response.data.token) {
//         const { token, uid, fullName, email, country, phone } = response.data;

//         // ✅ Store in sessionStorage
//         sessionStorage.setItem("token", token);
//         sessionStorage.setItem("uid", uid);
//         sessionStorage.setItem("fullName", fullName);
//         sessionStorage.setItem("email", email);
//         sessionStorage.setItem("country", country);
//         sessionStorage.setItem("phone", phone);

//         // ✅ Debug log to verify country storage
//         console.log("✅ User login successful - Country stored:", country);

//         // ✅ Also store in localStorage (fallback for pages like PaymentSuccess)
//         localStorage.setItem("token", token);
//         localStorage.setItem("uid", uid);

//         // ✅ Redirect user
//         navigate(
//           redirectPath.startsWith("/stis2025")
//             ? redirectPath.replace("/stis2025", "")
//             : redirectPath
//         );
//       }
//     } catch (error) {
//       setMessage("Invalid credentials. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Navbar />

//       <div className="member-access-page">
//         <main className={`member-access-container ${loading ? "blur" : ""}`}>
//           {/* Login Section */}
//           <div className="login-box">
//             <h2>Member Login</h2>

//             <div className="form-field">
//               <input
//                 type="email"
//                 id="email"
//                 placeholder=" "
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//                 autoComplete="email"
//               />
//               <label htmlFor="email">Email</label>
//             </div>

//             <div className="form-field">
//               <input
//                 type={showPassword ? "text" : "password"}
//                 id="password"
//                 placeholder=" "
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//                 autoComplete="current-password"
//               />
//               <label htmlFor="password">Password</label>
//               <span
//                 className="password-toggle"
//                 onClick={() => setShowPassword((prev) => !prev)}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </span>
//             </div>

//             <div className="remember-me">
//               <label>
//                 <input
//                   type="checkbox"
//                   checked={rememberMe}
//                   onChange={(e) => setRememberMe(e.target.checked)}
//                 />
//                 Remember Me
//               </label>
//             </div>

//             <div className="login-actions">
//               <p
//                 className="forgot-link"
//                 onClick={() => navigate("/forgot-password")}
//               >
//                 Forgot Password?
//               </p>
//             </div>

//             <button
//               className="login-btn"
//               onClick={handleLogin}
//               disabled={loading}
//             >
//               {loading ? "Logging in..." : "Login"}
//             </button>

//             {message && <p className="login-error-message">{message}</p>}
//           </div>

//           {/* Register Section */}
//           <div className="register-box">
//             <h2>New Member</h2>
//             <p>
//               Join <strong>STIS 2025</strong> to build your online profile,
//               showcase your research, and enjoy exclusive conference benefits.
//             </p>
//             <button
//               className="register-btn"
//               onClick={() => navigate("/register")}
//             >
//               Sign Up
//             </button>
//           </div>
//         </main>

//         {loading && (
//           <div className="overlay">
//             <div className="loader" />
//             <p style={{ color: "#fff", marginTop: "1rem" }}>Logging in...</p>
//           </div>
//         )}
//       </div>

//       <br />
//       <br />
//       <Footer />
//     </>
//   );
// };

// export default MemberAccess;


import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./MemberAccess.css";

const MemberAccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirectPath = searchParams.get("redirect") || "/abstract-submission";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [step, setStep] = useState(1); // Step 1 = check email, Step 2 = enter password
  const showNetworkTip = /no registered email/i.test(message);

  useEffect(() => {
    const rememberedEmail = localStorage.getItem("rememberedEmail");
    const rememberedPassword = localStorage.getItem("rememberedPassword");
    if (rememberedEmail) {
      setEmail(rememberedEmail); // ✅ Prefill email
      setRememberMe(true);

      // ❌ Don't auto-skip to step 2
      // ✅ Instead, when user clicks "Next", password can be prefilled
      if (rememberedPassword) {
        setPassword(rememberedPassword);
      }
    }
  }, []);

  // 🔹 Step 1: Check if email exists
  const handleCheckEmail = async () => {
    setLoading(true);
    setMessage("");
    try {
      const normalizedEmail = email.trim().toLowerCase();
      const res = await axios.post("https://api.rescons.in/check-email", {
        email: normalizedEmail,
      });
      if (res.data.message === "Email exists") {
        setEmail(normalizedEmail);
        setStep(2); // Move to password step
      }
    } catch (err) {
      if (!err.response) {
        setMessage("Network issue detected. Please try switching to a personal hotspot and retry.");
      } else {
        setMessage(err.response?.data?.message || "No registered email");
      }
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Step 2: Login with password
  const handleLogin = async () => {
    setLoading(true);
    setMessage("");

    const normalizedEmail = email.trim().toLowerCase();

    if (rememberMe) {
      localStorage.setItem("rememberedEmail", normalizedEmail);
      localStorage.setItem("rememberedPassword", password);
    } else {
      localStorage.removeItem("rememberedEmail");
      localStorage.removeItem("rememberedPassword");
    }

    try {
      const response = await axios.post("https://api.rescons.in/login", {
        email: normalizedEmail,
        password,
      });

      if (response.data.token) {
        const { token, uid, fullName, email, country, phone } = response.data;

        // ✅ Store in sessionStorage
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("uid", uid);
        sessionStorage.setItem("fullName", fullName);
        sessionStorage.setItem("email", email);
        sessionStorage.setItem("country", country);
        sessionStorage.setItem("phone", phone);

        // ✅ Also store in localStorage (fallback for pages like PaymentSuccess)
        localStorage.setItem("token", token);
        localStorage.setItem("uid", uid);

        // ✅ Redirect with a full page reload (one-time refresh after login)
        const hasStisPrefix = window.location.pathname.includes("/stis2025");
        const targetPath = redirectPath.startsWith("/stis2025")
          ? redirectPath.replace("/stis2025", "")
          : redirectPath;
        const finalPath = (hasStisPrefix ? "/stis2025" : "") + targetPath;
        window.location.href = finalPath || "/";
      }
    } catch (error) {
      setMessage(
        error.response?.data?.message || "Invalid credentials. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClearSavedData = () => {
    try {
      localStorage.removeItem("rememberedEmail");
      localStorage.removeItem("rememberedPassword");
      localStorage.removeItem("token");
      localStorage.removeItem("uid");

      sessionStorage.removeItem("token");
      sessionStorage.removeItem("uid");
      sessionStorage.removeItem("fullName");
      sessionStorage.removeItem("email");
      sessionStorage.removeItem("country");
      sessionStorage.removeItem("phone");

      setEmail("");
      setPassword("");
      setRememberMe(false);
      setMessage("Saved data cleared.");
    } catch (e) {
      setMessage("Unable to clear saved data. Please clear site data from your browser settings.");
    }
  };

  return (
    <>
      <Navbar />

      <div className="member-access-page">
        <main className={`member-access-container ${loading ? "blur" : ""}`}>
          {/* Login Section */}
          <div className="login-box">
            {showNetworkTip && (
              <div
                style={{
                  marginBottom: "10px",
                  background: "#fff3cd",
                  color: "#856404",
                  border: "1px solid #ffeeba",
                  borderRadius: "6px",
                  padding: "10px 12px",
                  fontWeight: 600
                }}
              >
                If you see error No Registered Email, kindly switch your network to personal hotspot and then login.
              </div>
            )}
            <h2>Member Login</h2>

            {/* Step 1: Enter Email */}
            {step === 1 && (
              <div className="form-field slide-in">
                <input
                  type="email"
                  id="email"
                  placeholder=" "
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                />
                <label htmlFor="email">Email</label>

                <button
                  className="next-btn"
                  onClick={handleCheckEmail}
                  disabled={loading || !email}
                >
                  {loading ? "Checking..." : "Next"}
                </button>
              </div>
            )}

            {/* Step 2: Enter Password */}
            {step === 2 && (
              <>
                <div className="form-field slide-in">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder=" "
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    autoComplete="current-password"
                  />
                  <label htmlFor="password">Password</label>
                  <span
                    className="password-toggle"
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>

                <div className="remember-me">
                  <label>
                    <input
                      type="checkbox"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                    Remember Me
                  </label>
                </div>

                <div className="login-actions">
                  <p
                    className="forgot-link"
                    onClick={() => navigate("/forgot-password")}
                  >
                    Forgot Password?
                  </p>
                </div>

                <button
                  className="login-btn"
                  onClick={handleLogin}
                  disabled={loading}
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
              </>
            )}

            {message && <p className="login-error-message">{message}</p>}
            <p
              onClick={handleClearSavedData}
              style={{
                marginTop: "8px",
                color: "#0d6efd",
                cursor: "pointer",
                textDecoration: "underline",
                display: "inline-block"
              }}
            >
              Clear cached data
            </p>
          </div>

          {/* Register Section */}
          <div className="register-box">
            <h2>New Member</h2>
            <p>
              Join <strong>STIS 2025</strong> to build your online profile,
              showcase your research, and enjoy exclusive conference benefits.
            </p>
            <button
              className="register-btn"
              onClick={() => navigate("/register")}
            >
              Sign Up
            </button>
          </div>
        </main>

        {loading && (
          <div className="overlay">
            <div className="loader" />
            <p style={{ color: "#fff", marginTop: "1rem" }}>Please wait...</p>
          </div>
        )}
      </div>

      <br />
      <br />
      <Footer />
    </>
  );
};

export default MemberAccess;


